var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfilePicture = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  d: "M28.835 19.64A7.493 7.493 0 1 0 18.238 9.043 7.493 7.493 0 0 0 28.835 19.64ZM29.05 23c-2.936 3.662-8.548 3.519-11.29-.29-6.26 2.162-10.736 8.105-10.736 15.074 10.52 1.767 20.765 1.882 31.888 0 .657-6.637-3.782-12.397-9.863-14.784Z"
})));
export default SvgProfilePicture;